import service from '@/utils/request'
import {apiURL} from "@/config/settings";

// @Summary 获取所有工具集的路由
// @Produce  application/json
// @Router /content/get_routes/
export const get_routes = () => {
    return service({
        url: `${apiURL}/content/get_routes/`,
        method: 'get',
    })
}

// @Summary 通过唯一标识获取设置
// @Produce  application/json
// @Router /content/get_setting/{tag}/
export const get_setting = (tag) => {
    return service({
        url: `${apiURL}/content/get_setting/${tag}/`,
        method: 'get',
    })
}

// @Summary 获取工具集下的所有分类
// @Produce  application/json
// @Router /content/get_toolset_categories/{rootPath}/
export const get_toolset_categories = (rootPath) => {
    return service({
        url: `${apiURL}/content/get_toolset_categories/${rootPath}/`,
        method: 'get',
    })
}

// @Summary 获取分类下所有组件的简化基本信息
// @Produce  application/json
// @Router /content/get_category_components/{id}/
export const get_category_components = (id) => {
    return service({
        url: `${apiURL}/content/get_category_components/${id}/`,
        method: 'get',
    })
}

// @Summary 通过 ID 获取单个组件
// @Produce  application/json
// @Router /content/get_enabled_component/{id}/
export const get_component_from_id = (id) => {
    return service({
        url: `${apiURL}/content/get_component_from_id/${id}/`,
        method: 'get',
    })
}

export const get_component_from_name = (category_name, name_in_url) =>{
    return service({
        url: `${apiURL}/content/get_component_from_name/${category_name}/${name_in_url}/`,
        method: 'get',
    })
}

// @Summary 获取搜索用的电池列表
// @Produce  application/json
// @Router /content/get_search_list/{toolset_name}/
export const get_search_list = (toolset_name) => {
    return service({
        url: `${apiURL}/content/get_search_list/${toolset_name}/`,
        method: 'get',
    })
}

// @Summary 获取标签
// @Produce  application/json
// @Router /content/get_tags/
export const get_tags = () => {
    return service({
        url: `${apiURL}/content/get_tags/`,
        method: 'get',
    })
}
